import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { DentalAttendanceProcedure } from "@/@types/esus/DentalAttendanceProcedure";

type IndicatorEsbB5AttendancesHistoryItemProps = {
	dentalAttendanceProcedure: DentalAttendanceProcedure;
};

export function IndicatorEsbB5DentalAttendanceProceduresHistoryItem({
	dentalAttendanceProcedure,
}: Readonly<IndicatorEsbB5AttendancesHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{dentalAttendanceProcedure.healthTeam1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{dentalAttendanceProcedure.healthUnit1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{dentalAttendanceProcedure.professional1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{dentalAttendanceProcedure.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Exame/Procedimento: </span>
						{[
							dentalAttendanceProcedure.procedure?.procedureCode?.toUpperCase() ?? "",
							dentalAttendanceProcedure.procedure?.name?.toUpperCase() ?? "",
						].join(" - ") || "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Quantidade: </span>
						{dentalAttendanceProcedure.quantity ?? 0}
					</p>
				</Col>
			</Row>
		</>
	);
}
